import React from 'react';

function EditIcon(props: React.SVGAttributes<{}>) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width="40" height="40" fill="white" />
            <path
                d="M20.0001 33.3333H34.1667M30.0001 16.6667L35.0001 11.6667L28.3334 5L23.3334 10M30.0001 16.6667L13.3334 33.3333H6.66675V26.6667L23.3334 10M30.0001 16.6667L23.3334 10"
                stroke="#2E2E2E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default EditIcon;
